/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Evidence,
    EvidenceFromJSON,
    EvidenceFromJSONTyped,
    EvidenceToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface EvidencesListResponse
 */
export interface EvidencesListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof EvidencesListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<Evidence>}
     * @memberof EvidencesListResponse
     */
    entries: Array<Evidence>;
}

export function EvidencesListResponseFromJSON(json: any): EvidencesListResponse {
    return EvidencesListResponseFromJSONTyped(json, false);
}

export function EvidencesListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidencesListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(EvidenceFromJSON)),
    };
}

export function EvidencesListResponseToJSON(value?: EvidencesListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(EvidenceToJSON)),
    };
}


